import axios from 'axios';
import axiosReqUpload from "../utils/axiosReqUpload";
// axiosReqUpload
import { useUserStore } from '@/framework/store/user';
import { baseApi } from "./base_const"


/**
 * tbox导入模块下载
 */
export function downloadImportTboxTemplate() {

    const { access_token, userInfo } = useUserStore();
    const myAxiosReq = axios.create({
        headers: {
            Authorization: `Bearer ${access_token}`,
            account_id: userInfo?.accountId
        }
    })
    return myAxiosReq
        .get(`${baseApi}/board/v1/mgmt/tbox/excel?request_no = ${new Date().getTime()}`, {
            responseType: 'blob'
        })
}


 // 导入TBOX
 export function importTboxHttpReq(data) {
    return axiosReqUpload({
        url: `${baseApi}/board/v1/mgmt/tbox/import`,
        method: 'post',
        data,
    });
}


/**
 * tbox导入模块下载
 */
export function downloadImportGlonassTemplate() {

    const { access_token, userInfo } = useUserStore();
    const myAxiosReq = axios.create({
        headers: {
            Authorization: `Bearer ${access_token}`,
            account_id: userInfo?.accountId
        }
    })
    return myAxiosReq
        .get(`${baseApi}/board/v1/mgmt/glonass/excel?request_no = ${new Date().getTime()}`, {
            responseType: 'blob'
        })
}


 // 导入TBOX
 export function importGlonassHttpReq(data) {
    return axiosReqUpload({
        url: `${baseApi}/board/v1/mgmt/glonass/import`,
        method: 'post',
        data,
    });
}


/**
 *车辆孪生-->车辆列表-->导入发运日期： 批量导入模板
 * @param {*} companyTruckId
 * @returns
 */
 export function getImportDeliverTimeTemplate() {
    const { access_token, userInfo } = useUserStore();
    const myAxiosReq = axios.create({
        headers: {
            Authorization: `Bearer ${access_token}`,
            account_id: userInfo?.accountId
        }
    })
    return myAxiosReq
        .get(`${baseApi}/board/v1//mgmt/truck/commonImportTemplate?importType=DELIVER_TYPE&request_no = ${new Date().getTime()}`, {
            responseType: 'blob'
        })
}


// 车辆孪生-->车辆列表-->导入发运日期： 导入
export function importDeliverTimeHttpReq(file) {

    const data = new FormData(); // 创建form对象
    data.append("file", file); // 通过append向form对象添加数据

    return axiosReqUpload({
        url: `${baseApi}/board/v1/mgmt/truck/import-update?importType=DELIVER_TYPE`,
        method: 'post',
        data,
    });
  }


